import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/CourseDetailModal.css';

export default function CourseDetailModal({ course, onClose }) {
  const navigate = useNavigate();

  if (!course) return null;

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}/${month}/${day}`;
  };

  const parseCourseCount = (value) => {
    if (value === null || value === undefined) return 0;
    if (typeof value === 'number' && Number.isFinite(value)) return value;
    const parsed = parseInt(String(value), 10);
    return Number.isNaN(parsed) ? 0 : parsed;
  };

  const handleStartPractice = () => {
    navigate(`/course/${course.cid}/practice`);
  };

  const totalCount = parseCourseCount(course.content_count ?? course.length);
  const hasStatus = !!course.status;
  const currentIndex = Number.isFinite(Number(course.current_index)) ? Math.max(0, Number(course.current_index)) : 0;
  const displayIndex = hasStatus ? Math.min(currentIndex + 1, totalCount || currentIndex + 1) : 0;

  return (
    <div className="course-modal-overlay" onClick={onClose}>
      <div className="course-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="course-modal-close-btn" onClick={onClose} aria-label="Close">
          &times;
        </button>
        
        <div className="course-modal-header">
          <h2 className="course-modal-title">{course.title}</h2>
          {course.generated_at && (
            <p className="course-modal-date">Created on {formatDate(course.generated_at)}</p>
          )}
        </div>

        <div className="course-modal-body">
          <p className="course-modal-description">
            {course.description || "No description available."}
          </p>
          
          <div className="course-modal-progress">
            <span>Progress:</span>
            <span>{displayIndex} / {totalCount}</span>
          </div>
        </div>

        <div className="course-modal-actions">
          <button className="course-modal-btn" onClick={handleStartPractice}>
            Start Practice
          </button>
        </div>
      </div>
    </div>
  );
}
